'use strict';

module.exports.tartanPreview = require('./tartan-preview');
module.exports.tartanImage = require('./tartan-image');
module.exports.applicationTitle = require('./application-title');

module.exports.uiPagination = require('./ui-pagination');
module.exports.uiModal = require('./ui-modal');
module.exports.uiDropdown = require('./ui-dropdown');
module.exports.uiIcon = require('./ui-icon');
module.exports.uiLoader = require('./ui-loader');



//////////////////
// WEBPACK FOOTER
// ./src/scripts/shared/components/index.js
// module id = 193
// module chunks = 0